module.exports = __webpack_public_path__ + "static/img/bottomsnap.25eb6a29.svg";